import { connect } from 'react-redux';
import { show, hide } from 'js/store/actions/modal';
import { clearGenerators } from 'js/store/actions/graphGeneratorData';
import SelectedGeneratorsMobile from 'js/components/legacy/SelectedGeneratorsMobile';
export default connect(function (state, ownProps) {
  return {
    plotGenerators: state.graphGeneratorData[ownProps.plotId]
  };
}, function (dispatch, ownProps) {
  return {
    openSelectSourcesModal: function openSelectSourcesModal(props) {
      dispatch(show('SelectSourcesModal', props));
    },
    plotClearGenerators: function plotClearGenerators() {
      return dispatch(clearGenerators(ownProps.plotId));
    },
    modalClose: function modalClose() {
      dispatch(hide('SelectSourcesModal'));
    }
  };
})(SelectedGeneratorsMobile);